<div style="background-color: #6102aa;">
<div class="container">
    <h1 class="title" [ngStyle]="getTitleStyle()">
        <span style="color: white;">Amplify Your Earnings,</span>
    <span style="color: red;"> Accelerate<br> Your Growth</span><span style="color: white;">
     with Calsoft</span>
    </h1>
    <div class="circle red" [ngStyle]="getStyle('red')"></div>
  <div class="circle green" [ngStyle]="getStyle('green')"></div>
  <div class="circle blue" [ngStyle]="getStyle('blue')"></div>
</div>

<div class="scroll-space"></div>
</div>